import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    background: 'linear-gradient(270deg, #7B61FF 0%, #0F123F 100%)',
    borderRadius: '12px',
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '450px',
  },
  textContent: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
  },
  title: {
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '1.2',
    color: '#ffffff',
  },
  learnMoreLink: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#ffffff',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontFamily: 'inherit',
    '&:hover': {
      color: '#E0E0E0',
    },
  },
  creditPill: {
    backgroundColor: '#F5F5F7',
    borderRadius: '8px',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  },
  creditAmount: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#0F123F',
    fontFamily: 'inherit',
  },
})

export default styles
export type StylesClassNames = StylesClasses<typeof styles>
